import { render, staticRenderFns } from "./BigScreenLinks.vue?vue&type=template&id=16b12da4&scoped=true"
import script from "./BigScreenLinks.vue?vue&type=script&lang=js"
export * from "./BigScreenLinks.vue?vue&type=script&lang=js"
import style0 from "./BigScreenLinks.vue?vue&type=style&index=0&id=16b12da4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b12da4",
  null
  
)

export default component.exports